import { Pipe, PipeTransform } from '@angular/core';



export class PixelConverter implements PipeTransform {
  transform(value: string | number, args: string[]): any {
    if (value === undefined) {
        return;
    }
    if (typeof value === 'string') {
        return value;
    }
    if (typeof value === 'number') {
        return value + 'px';
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'px'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
